<template>
  <div>
    <nav class="navbar">
      <div class="navbar-brand">
        <router-link class="navbar-item" to="/">
          <img src="../assets/eco_logo.png" />
        </router-link>
      </div>

      <div id="navMenubd-example" class="navbar-menu">
        <div class="navbar-start">
          <!--
                    <div class="navbar-item has-dropdown is-hoverable">
                      <a class="navbar-link " href="http://bulma.io/blog/">
                        Blog
                      </a>
                      <div id="blogDropdown" class="navbar-dropdown " data-style="width: 18rem;">

                          <a class="navbar-item" href="/2017/08/03/list-of-tags/">
                            <div class="navbar-content">
                              <p>
                                <small class="has-text-info">03 Aug 2017</small>
                              </p>
                              <p>New feature: list of tags</p>
                            </div>
                          </a>

                          <a class="navbar-item" href="/2017/08/01/bulma-bootstrap-comparison/">
                            <div class="navbar-content">
                              <p>
                                <small class="has-text-info">01 Aug 2017</small>
                              </p>
                              <p>Bulma / Bootstrap comparison</p>
                            </div>
                          </a>

                          <a class="navbar-item" href="/2017/07/24/access-previous-bulma-versions/">
                            <div class="navbar-content">
                              <p>
                                <small class="has-text-info">24 Jul 2017</small>
                              </p>
                              <p>Access previous Bulma versions</p>
                            </div>
                          </a>

                        <a class="navbar-item" href="http://bulma.io/blog/">
                          More posts
                        </a>
                        <hr class="navbar-divider">
                        <div class="navbar-item">
                          <div class="navbar-content">
                            <div class="level is-mobile">
                              <div class="level-left">
                                <div class="level-item">
                                  <strong>Stay up to date!</strong>
                                </div>
                              </div>
                              <div class="level-right">
                                <div class="level-item">
                                  <a class="button bd-is-rss is-small" href="http://bulma.io/atom.xml">
                                    <span class="icon is-small">
                                      <i class="fas fa-rss"></i>
                                    </span>
                                    <span>Subscribe</span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="navbar-item has-dropdown is-hoverable">
                      <div class="navbar-link">
                        More
                      </div>
                      <div id="moreDropdown" class="navbar-dropdown ">
                        <a class="navbar-item " href="http://bulma.io/extensions/">
                          <div class="level is-mobile">
                            <div class="level-left">
                              <div class="level-item">
                                <p>
                                  <strong>Extensions</strong>
                                  <br>
                                  <small>Side projects to enhance Bulma</small>
                                </p>
                              </div>
                            </div>
                            <div class="level-right">
                              <div class="level-item">
                                <span class="icon has-text-info">
                                  <i class="fa fa-plug"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                    <a class="navbar-item " href="http://bulma.io/expo/">
                      <span class="bd-emoji">🎨</span>
                      Expo
                    </a>
                    <a class="navbar-item " href="http://bulma.io/love/">
                      <span class="bd-emoji">❤︝</span>
                      Love
                    </a>
                    -->
        </div>

        <div class="navbar-end">
          <div class="navbar-item">
            <div class="field is-grouped">
              <!--
                        <p class="control">
                          <a class="bd-tw-button button"
                            data-social-network="Twitter"
                            data-social-action="tweet"
                            data-social-target="http://bulma.io"
                            target="_blank"
                            href="https://twitter.com/intent/tweet?text=Bulma: a modern CSS framework based on Flexbox&hashtags=bulmaio&url=http://bulma.io&via=jgthms">
                            <span class="icon">
                              <i class="fab fa-twitter"></i>
                            </span>
                            <span>
                              Tweet
                            </span>
                          </a>

                        </p>
                        <p class="control">
                          <a class="button is-primary" href="https://github.com/jgthms/bulma/archive/0.5.1.zip">
                            <span class="icon">
                              <i class="fas fa-download"></i>
                            </span>
                            <span>Download</span>
                          </a>
                        </p>
                        -->

              <!-- User Status -->
              <div class="navbar-item has-dropdown is-hoverable">
                <a class="navbar-link">
                  <span class="icon is-medium">
                    <span class="fa-stack">
                      <i class="fas fa-circle fa-stack-2x"></i>
                      <i class="fas fa-user fa-stack-1x fa-inverse"></i>
                    </span>
                  </span>
                  &nbsp; Welcome, {{ user_name }}
                </a>
                <div class="navbar-dropdown ">
                  <router-link class="navbar-item " to="/profile"> <i class="fas fa-user"></i> &nbsp; Profile </router-link>
                  <hr class="navbar-divider" />
                  <router-link class="navbar-item" to="/logout"> <i class="fas fa-sign-out-alt"></i> &nbsp; Logout </router-link>
                </div>
              </div>
              <!-- End User Status -->
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div class="columns is-fullheight is-main-body">
      <div class="column is-2 is-sidebar-menu is-hidden-mobile is-sidebar-menu-padding">
        <b-menu>
          <b-menu-list label="Menu">
            <b-menu-item class="menu-item" tag="router-link" icon-pack="mdi" icon="view-dashboard" to="/" exact label="Dashboard"></b-menu-item>
            <b-menu-item
              class="menu-item"
              tag="router-link"
              icon-pack="mdi"
              icon="cart-arrow-down"
              to="/order"
              v-can="'add_order|edit_order|delete_order|issue_receipt|issue_tax_invoice'"
              label="คำสั่งซื้อจากลูกค้า"
            ></b-menu-item>
            <b-menu-item
              class="menu-item"
              tag="router-link"
              icon-pack="mdi"
              icon="sale"
              to="/quotation"
              v-can="'add_quotation|edit_quotation|delete_quotation|issue_quotation'"
              label="ใบเสนอราคา"
            ></b-menu-item>
            <b-menu-item
              class="menu-item"
              tag="router-link"
              icon-pack="mdi"
              icon="cart-arrow-up"
              to="/purchaseorder"
              v-can="'add_po|edit_po|delete_po|issue_po|receive_po_item|download_po_pdf'"
              label="Purchase Order"
            ></b-menu-item>
            <b-menu-item class="menu-item" tag="router-link" icon-pack="mdi" icon="package-variant" to="/inventory" v-can="'view_inventory'" label="สินค้าคงคลัง"></b-menu-item>
            <b-menu-item class="menu-item" tag="router-link" icon-pack="mdi" icon="account-tie" to="/customer" v-can="'add_customer|edit_customer|delete_customer'" label="ลูกค้า"></b-menu-item>
            <b-menu-item class="menu-item" tag="router-link" icon-pack="mdi" icon="contact-mail" to="/supplier" v-can="'add_supplier|edit_supplier|delete_supplier'" label="ซัพพลายเออร์"></b-menu-item>

            <b-menu-item
              class="menu-item"
              icon-pack="mdi"
              icon="finance"
              v-can="'report|report_order|report_order_supplier|report_order_sales|report_purchase|report_tax_invoice|report_account_receivable|report_inventory'"
              :active="this.path == 'report'"
              :expanded="this.path == 'report'"
            >
              <template slot="label" slot-scope="props">
                รายงาน
                <b-icon class="is-pulled-right" pack="mdi" :icon="props.expanded ? 'menu-down' : 'menu-left'"> </b-icon>
              </template>
              <b-menu-item class="menu-item" tag="router-link" icon-pack="mdi" icon="finance" to="/report/order" v-can="'report|report_order'" label="รายงานยอดขาย"></b-menu-item>
              <b-menu-item
                class="menu-item"
                tag="router-link"
                icon-pack="mdi"
                icon="finance"
                to="/report/order_supplier"
                v-can="'report|report_order_supplier'"
                label="รายงานยอดขาย (Supplier)"
              ></b-menu-item>
              <b-menu-item class="menu-item" tag="router-link" icon-pack="mdi" icon="finance" to="/report/order_sales" v-can="'report|report_order_sales'" label="รายงานยอดขาย (Sales)"></b-menu-item>
              <b-menu-item class="menu-item" tag="router-link" icon-pack="mdi" icon="finance" to="/report/purchase" v-can="'report|report_purchase'" label="รายงานการสั่งซื้อ"></b-menu-item>
              <b-menu-item class="menu-item" tag="router-link" icon-pack="mdi" icon="finance" to="/report/tax_invoice" v-can="'report|report_tax_invoice'" label="รายงาน Tax Invoice"></b-menu-item>
              <b-menu-item
                class="menu-item"
                tag="router-link"
                icon-pack="mdi"
                icon="finance"
                to="/report/account_receivable"
                v-can="'report|report_account_receivable'"
                label="รายงานลูกหนี้"
              ></b-menu-item>
              <b-menu-item class="menu-item" tag="router-link" icon-pack="mdi" icon="finance" to="/report/inventory" v-can="'report|report_inventory'" label="รายงานสินค้าคงคลัง"></b-menu-item>
            </b-menu-item>
          </b-menu-list>

          <b-menu-list label="Settings">
            <b-menu-item
              class="menu-item"
              tag="router-link"
              icon-pack="mdi"
              icon="package"
              to="/product/adjust"
              v-can="'add_product|edit_product|delete_product'"
              label="ปรับยอดผลิตภัณฑ์"
            ></b-menu-item>
            <b-menu-item class="menu-item" tag="router-link" icon-pack="mdi" icon="sitemap" to="/product" v-can="'add_product|edit_product|delete_product'" label="ตั้งค่าผลิตภัณฑ์"></b-menu-item>
            <b-menu-item class="menu-item" tag="router-link" icon-pack="mdi" icon="account-settings" to="/user" v-can="'add_user|edit_user|delete_user'" label="ตั้งค่าผู้ใช้งาน"></b-menu-item>
            <b-menu-item class="menu-item" tag="router-link" icon-pack="mdi" icon="account-group" to="/group" v-can="'add_group|edit_group|delete_group'" label="ตั้งค่ากลุ่มผู้ใช้งาน"></b-menu-item>
            <b-menu-item class="menu-item" tag="router-link" icon-pack="mdi" icon="settings" to="/config" v-can="'config'" label="ตั้งค่าทั่วไป"></b-menu-item>
          </b-menu-list>
        </b-menu>

        <div class="column has-text-centered has-text-grey is-size-7">
          <div class="system-stamp">
            Ecolution Management System<br />
            Version 0.0.3
          </div>
        </div>
      </div>
      <div class="column is-offset-2 is-main-content">
        <app-breadcrumb></app-breadcrumb>
        <router-view />
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue';
import Auth from '@/libraries/auth.js';
import User from '@/libraries/user.js';

export default {
  name: 'Page',
  components: {
    'app-breadcrumb': Breadcrumb,
  },
  data() {
    return {
      path: '',
    };
  },
  methods: {
    renderMenu() {
      let path = this.$route.path.split('/');
      this.path = path[1];
      // console.log(this.path);
    },
  },
  updated() {
    this.renderMenu();
  },
  created() {
    this.renderMenu();
  },
  computed: {
    user_name() {
      return User.getName();
    },
  },
  watch: {},
};
</script>

<style lang="scss">
// Import Bulma and Buefy styles
@import 'static/global.scss';

.menu-item {
  font-size: 0.8rem;
}
.is-sidebar-menu-padding {
  padding-left: 1rem;
  padding-right: 0.3rem;
  padding-top: 1rem;
  background: $grey-dark;
  position: fixed !important;
  max-height: none !important;
  height: 100% !important;
  margin-left: 0;
  li {
    a {
      color: $white;
    }
  }
  .router-link-exact-active {
    background-color: $primary;
    color: $white;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/page.vue